import React from "react";
import { Card, Tag, Button, Typography } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { ProposalModel } from "../model/proposals.ui";
import { getStatusConfig, formatDisplayDate } from "./proposalHelpers";

const { Text } = Typography;

export interface ProposalMobileCardProps {
  proposal: ProposalModel;
  onSelect: (proposal: ProposalModel) => void;
}

export const ProposalMobileCard: React.FC<ProposalMobileCardProps> = ({
  proposal,
  onSelect,
}) => {
  const statusInfo = getStatusConfig(proposal.status);

  return (
    <Card
      hoverable
      style={{
        borderRadius: 10,
        border: "1px solid #f0f0f0",
      }}
      styles={{
        body: {
          padding: 14
        }
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: 6,
        }}
      >
        <Text strong style={{ fontSize: 15 }}>
          {proposal.propose_code || "-"}
        </Text>
        <Tag color={statusInfo.color} icon={statusInfo.icon}>
          {statusInfo.label}
        </Tag>
      </div>

      <div style={{ marginBottom: 8 }}>
        <Text type="secondary" style={{ fontSize: 12, display: "block" }}>
          受取人: {/* Người nhận: */}{proposal.recipient_name || "-"}
        </Text>
        <Text type="secondary" style={{ fontSize: 12, display: "block" }}>
          担当者ID: {/* ID người phụ trách: */}{proposal.representative_id || "-"}
        </Text>
        <Text type="secondary" style={{ fontSize: 12, display: "block" }}>
          有効期間: {/* Thời gian hiệu lực: */}{formatDisplayDate(proposal.effective_from)} ～{" "}
          {formatDisplayDate(proposal.effective_to)}
        </Text>
      </div>

      <div
        style={{
          paddingTop: 8,
          borderTop: "1px dashed #f0f0f0",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Button
          type="primary"
          ghost
          size="small"
          icon={<EyeOutlined />}
          onClick={() => onSelect(proposal)}
          style={{ borderRadius: 6 }}
        >
          詳細を見る {/* Xem chi tiết */}
        </Button>
      </div>
    </Card>
  );
};
